import { useEffect } from "react";

function capitalizeFirstLetters(str: string) {
  return str
    .replace("/", "")
    .replace(/-/g, " ")
    .split("?")[0]
    .replace(/\//g, " ")
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

function useTabTitle() {
  useEffect(() => {
    // Function to update the tab title based on the window's location
    const updateTabTitle = () => {
      const currentPath = window.location.pathname;
      document.title = capitalizeFirstLetters(currentPath);
    };

    // Call the function initially to set the title
    updateTabTitle();

    // Listen for popstate event, which occurs when location changes
    window.addEventListener("popstate", updateTabTitle);

    // Also handle changes in the history API (for example, when using react-router)
    window.addEventListener("pushState", updateTabTitle);
    window.addEventListener("replaceState", updateTabTitle);

    return () => {
      window.removeEventListener("popstate", updateTabTitle);
      window.removeEventListener("pushState", updateTabTitle);
      window.removeEventListener("replaceState", updateTabTitle);
    };
  }, []);
}

export default useTabTitle;
